import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Search, Compass, Share2, Landmark, Trees, Building2, Palmtree, Waves, Church, MapPin, Info, ArrowRight } from "lucide-react";
import { Helmet } from "react-helmet-async";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export default function Places() {
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.05 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
  };

  // 🔥 Places Data (28 Locations - Original 22 + New 6) 🔥
  const placesData = [
    {
      id: 1,
      name: "പഴയങ്ങാടി",
      englishName: "Payangadi",
      icon: Building2,
      color: "from-emerald-400 to-teal-500",
      description: "കല്യാശ്ശേരി മണ്ഡലത്തിലെ ഏറ്റവും പ്രധാനപ്പെട്ട വാണിജ്യ കേന്ദ്രം. പഴയങ്ങാടി പുഴയോരത്തായി സ്ഥിതിചെയ്യുന്ന ഈ നഗരം, റെയിൽവേ സ്റ്റേഷനും ബസ് സ്റ്റാൻഡും ഉൾപ്പെടുന്ന ഈ പ്രദേശത്തെ പ്രധാന ഗതാഗത ഹബ്ബാണ്. ഒരുപാട് കൊച്ചു ഗ്രാമങ്ങളെ പരസ്പരം ബന്ധിപ്പിക്കുന്ന ഈ നാടിന്റെ ഹൃദയഭാഗം കൂടിയാണിത്."
    },
    {
      id: 2,
      name: "കല്യാശ്ശേരി",
      englishName: "Kalliasseri",
      icon: Landmark,
      color: "from-blue-400 to-indigo-500",
      description: "മാങ്ങാട്ടുപറമ്പ് യൂണിവേഴ്സിറ്റി ക്യാമ്പസ്, കെൽട്രോൺ എന്നിവ സ്ഥിതി ചെയ്യുന്നതിനൊപ്പം, കേരളത്തിന്റെ രാഷ്ട്രീയ-സാമൂഹിക ചരിത്രത്തിൽ നിർണ്ണായകമായ പല കർഷക-കമ്മ്യൂണിസ്റ്റ് മുന്നേറ്റങ്ങൾക്കും സാക്ഷ്യം വഹിച്ച ഐതിഹാസികമായ മണ്ണ്."
    },
    {
      id: 3,
      name: "ചെറുകുന്ന്",
      englishName: "Cherukunnu",
      icon: Church,
      color: "from-amber-400 to-orange-500",
      description: "കല്യാശ്ശേരി മണ്ഡലത്തിലെ പ്രധാന വാണിജ്യ-തീർത്ഥാടന കേന്ദ്രങ്ങളിലൊന്ന്. ശ്രീ അന്നപൂർണേശ്വരി ക്ഷേത്രമാണ് നാടിൻറെ ലാൻഡ്മാർക് . ഒരുകാലത്ത് ഖാദി വ്യവസായത്തിനും കൈത്തറിക്കും വലിയ പേര് കേട്ടിരുന്ന പ്രദേശം കൂടിയാണിത്."
    },
    {
      id: 4,
      name: "മാട്ടൂൽ",
      englishName: "Mattool",
      icon: Waves,
      color: "from-cyan-400 to-blue-500",
      description: "അറബിക്കടലും വളപട്ടണം പുഴയും അതിരിടുന്ന, സവിശേഷമായ ഭൂപ്രകൃതിയുള്ള അതിമനോഹരമായ തീരദേശ ഗ്രാമം. മത്സ്യബന്ധനവും ഗൾഫ് കുടിയേറ്റവും പ്രധാന ജീവനോപാധിയാക്കിയ ഈ നാട്, മടക്കര പാലം വന്നതോടെ വിനോദസഞ്ചാരികളുടെ കൂടി പ്രിയപ്പെട്ട ഇടമായി മാറി. കടൽക്കാറ്റ് ആസ്വദിക്കാൻ ഒട്ടേറെപ്പേർ ദിവസവും ഇവിടെയെത്തുന്നു."
    },
    {
      id: 5,
      name: "പുതിയങ്ങാടി",
      englishName: "Puthiyangadi",
      icon: Waves,
      color: "from-teal-400 to-emerald-500",
      description: "മാടായി പഞ്ചായത്തിലെ ചരിത്രപ്രസിദ്ധമായ തീരദേശം. പുരാതനമായ ജുമാ മസ്ജിദിനും മത്സ്യബന്ധന തുറമുഖത്തിനും പേരുകേട്ട ഇവിടം, നൂറ്റാണ്ടുകൾ പഴക്കമുള്ള വ്യാപാര ബന്ധങ്ങളുടെയും ഇസ്ലാമിക പൈതൃകത്തിന്റെയും സാംസ്കാരിക കേന്ദ്രം കൂടിയാണ്. തനതായ ഭക്ഷണവിഭവങ്ങൾക്കും മതസൗഹാർദ്ദത്തിനും പുതിയങ്ങാടി എന്നും മാതൃകയാണ്."
    },
    {
      id: 6,
      name: "കണ്ണപുരം",
      englishName: "Kannapuram",
      icon: Trees,
      color: "from-rose-400 to-red-500",
      description: "നെയ്ത്തു വ്യവസായത്തിനും കർഷക മുന്നേറ്റങ്ങൾക്കും പേരുകേട്ട നാട്. കീഴറ, മൊട്ടമ്മൽ തുടങ്ങിയ ഗ്രാമങ്ങൾ ഉൾപ്പെടുന്ന ഈ പ്രദേശം തെയ്യം കലാരൂപങ്ങളുടെയും തോറ്റം പാട്ടുകളുടെയും ഈറ്റില്ലം കൂടിയാണ്. കണ്ണപുരം കീഴറയിലെ കൊടിമരവും കാവുകളും ഈ നാടിന്റെ പൈതൃകം വിളിച്ചോതുന്നു."
    },
    {
      id: 7,
      name: "പാപ്പിനിശ്ശേരി",
      englishName: "Pappinisseri",
      icon: MapPin,
      color: "from-indigo-400 to-purple-500",
      description: "വളപട്ടണം പുഴയുടെ തീരത്തുള്ള വ്യവസായിക ഗ്രാമം. പണ്ട് മുതലേ തടി വ്യവസായത്തിനും കോട്ടൺ, ഓട് കമ്പനികൾക്കും പേരുകേട്ടതാണ്."
    },
    {
      id: 8,
      name: "ചെറുതാഴം",
      englishName: "Cheruthazham",
      icon: Landmark,
      color: "from-orange-400 to-amber-500",
      description: "ചെണ്ടമേളങ്ങളുടെയും താളവാദ്യങ്ങളുടെയും നാട്. ശ്രീ രാഘവപുരം ക്ഷേത്രം (ഹനുമാരമ്പലം) സ്ഥിതിചെയ്യുന്നത് ഇവിടെയാണ്. ക്ഷേത്രകലകളെയും വാദ്യകലകളെയും നെഞ്ചിലേറ്റുന്ന ഒരുകൂട്ടം കലാകാരന്മാരുടെ സ്വന്തം ദേശം."
    },
    {
      id: 9,
      name: "വെങ്ങര",
      englishName: "Vengara",
      icon: Palmtree,
      color: "from-lime-400 to-green-500",
      description: "മാടായി പഞ്ചായത്തിലെ പ്രശാന്ത സുന്ദരമായ ഗ്രാമം. പുഴയും കണ്ടൽക്കാടുകളും നിറഞ്ഞ വെങ്ങര, വടക്കേ മലബാറിലെ അനുഷ്ഠാന കലയായ തെയ്യങ്ങളുടെ സജീവമായ സാന്നിധ്യം കൊണ്ട് സമ്പന്നമാണ്. ഗ്രാമീണത ഒട്ടും ചോർന്നുപോകാത്ത ഇടം."
    },
    {
      id: 10,
      name: "ഇരിണാവ്",
      englishName: "Irinave",
      icon: MapPin,
      color: "from-sky-400 to-blue-500",
      description: "കല്യാശ്ശേരി-പാപ്പിനിശ്ശേരി അതിർത്തിയിലുള്ള ചരിത്ര പ്രസിദ്ധമായ ദേശം. പഴയകാല കാർഷിക സംസ്‌കാരത്തിന്റെ നേർക്കാഴ്ചകൾ ഇന്നും നിലനിർത്തുന്ന ഇരിണാവ്, പ്രസിദ്ധമായ കാവുകൾക്കും പ്രാദേശിക ആഘോഷങ്ങൾക്കും പേരുകേട്ടതാണ്."
    },
    {
      id: 11,
      name: "താവം",
      englishName: "Thavam",
      icon: Waves,
      color: "from-teal-400 to-cyan-500",
      description: "ചെറുകുന്ന് പഞ്ചായത്തിലെ ഒരു മനോഹരമായ പുഴയോര ഗ്രാമം. താവം പള്ളിയും (Fathima Matha Church), അതിമനോഹരമായ പുഴയോരക്കാഴ്ചകളും ഈ ഗ്രാമത്തിന് പ്രത്യേക ഭംഗി നൽകുന്നു. മീൻപിടുത്തവും കൃഷിയും ഈ ഗ്രാമത്തിന്റെ ജീവനാഡിയാണ്."
    },
    {
      id: 12,
      name: "എരിപുരം",
      englishName: "Eripuram",
      icon: Building2,
      color: "from-violet-400 to-purple-500",
      description: "മാടായിപ്പാറയുടെ താഴെ, പഴയങ്ങാടി ടൗണിനോട് ചേർന്ന് കിടക്കുന്ന പ്രധാന വിദ്യാഭ്യാസ-വാണിജ്യ സിരാകേന്ദ്രം. ഒട്ടേറെ പ്രധാന സർക്കാർ സ്ഥാപനങ്ങളും വിദ്യാലയങ്ങളും സ്ഥിതി ചെയ്യുന്ന തിരക്കേറിയ കവലയാണിത്. പഴയങ്ങാടി പോലീസ് സ്റ്റേഷൻ സ്ഥിതിചെയ്യുന്നത് ഇവിടെയാണ്."
    },
    {
      id: 13,
      name: "മുട്ടം",
      englishName: "Muttam",
      icon: MapPin,
      color: "from-orange-400 to-red-500",
      description: "മാടായി പഞ്ചായത്തിന്റെ പടിഞ്ഞാറൻ അതിർത്തിയിൽ സ്ഥിതിചെയ്യുന്ന പ്രദേശം. മത്സ്യബന്ധനം, കൃഷി എന്നിവയാണ് ജീവനാഡി. ഒരുകാലത്ത് ജലഗതാഗതത്തിന് വലിയ പ്രാധാന്യമുണ്ടായിരുന്ന ഗ്രാമം."
    },
    {
      id: 14,
      name: "പിലാത്തറ",
      englishName: "Pilathara",
      icon: Building2,
      color: "from-fuchsia-400 to-pink-500",
      description: "മണ്ഡലത്തിന്റെ വടക്കേഭാഗത്തുള്ള അതിവേഗം വളരുന്ന ടൗൺ. പയ്യന്നൂരിൽ നിന്നും പഴയങ്ങാടിയിലേക്കും മാതമംഗലത്തേക്കുമുള്ള പ്രധാന റോഡുമാർഗ്ഗമാണ് പിലാത്തറ. ഇന്ന് വടക്കേ മലബാറിലെ തന്നെ പ്രധാനപ്പെട്ട ഒരു ഇടത്താവളമായി മാറിക്കഴിഞ്ഞു."
    },
    {
      id: 15,
      name: "നെരുവമ്പ്രം",
      englishName: "Neruvambram",
      icon: Trees,
      color: "from-green-400 to-emerald-500",
      description: "ഏഴോം പഞ്ചായത്തിലെ പ്രധാന ടൗൺ. നിരവധി വിദ്യാഭ്യാസ സ്ഥാപനങ്ങൾ നെരുവമ്പ്രത്തിന്റെ പ്രതേകതയാണ്. ചെറുതാഴം പഞ്ചായത്തുമായി അതിർത്തി പങ്കിടുന്നു."
    },
    {
      id: 16,
      name: "കണ്ണോം",
      englishName: "Kannom",
      icon: Trees,
      color: "from-emerald-400 to-green-500",
      description: "ഏഴോം പഞ്ചായത്തിലെ ശാന്തസുന്ദരമായ ഉൾനാടൻ ഗ്രാമം. നെൽക്കൃഷിയാണ് പ്രധാന ഉപജീവനമാർഗം. കണ്ണോം ശ്രീ അഞ്ചുതെങ്ങിൽ ഐവർ പരദേവതാ ക്ഷേത്രം കാവാണ് പ്രധാന ആരാധനാലയം. ഗ്രാമീണ നന്മകളും കാർഷിക പൈതൃകവും നെഞ്ചിലേറ്റുന്ന ജനതയാണ് ഈ നാടിന്റെ കരുത്ത്."
    },
    {
      id: 17,
      name: "കൊട്ടില",
      englishName: "Kottila",
      icon: Palmtree,
      color: "from-teal-400 to-cyan-500",
      description: "കണ്ടൽക്കാടുകളും പുഴയും അതിരിടുന്ന പ്രകൃതിരമണീയമായ പ്രദേശം. കൊട്ടില മുച്ചിലോട്ട് ഭഗവതി ക്ഷേത്രവും അവിടുത്തെ വലിയ കളിയാട്ടവും വടക്കേ മലബാറിൽ തന്നെ ഏറെ പ്രശസ്തമാണ്. പാരമ്പര്യവും പുഴയോരക്കാഴ്ചകളും ഒരുപോലെ ആസ്വദിക്കാൻ കഴിയുന്ന, പഴയകാല കൈത്തറി പാരമ്പര്യമുള്ള ഗ്രാമം."
    },
    {
      id: 18,
      name: "അതിയടം",
      englishName: "Athiyadam",
      icon: Landmark,
      color: "from-blue-400 to-sky-500",
      description: "ഏഴോം പഞ്ചായത്തിലും ചെറുതാഴം പഞ്ചായത്തിലുമായി സ്ഥിതിചെയ്യുന്ന മനോഹരമായ ഗ്രാമം. അതിയടം ശ്രീ പാലോട്ട്കാവ്, മുച്ചിലോട്ട് കാവ്, പുതിയ കാവ് തുടങ്ങി നിരവധി കാവുകളാൽ സമ്പന്നമാണ് പ്രദേശം. കൃഷിയും തദ്ദേശീയമായ കൂട്ടായ്മകളും ഈ നാടിനെ സജീവമാക്കി നിർത്തുന്നു."
    },
    {
      id: 19,
      name: "ചെങ്ങൽ",
      englishName: "Chengal",
      icon: MapPin,
      color: "from-rose-400 to-pink-500",
      description: "പഴയങ്ങാടിക്കടുത്തുള്ള ചരിത്രപ്രാധാന്യമുള്ള ഗ്രാമം. പഴയങ്ങാടി ബസ് സ്റ്റാൻഡ് സ്ഥിതിചെയ്യുന്നത് ചെങ്ങലിന്റെ പടിഞ്ഞാറൻ അതിർത്തിയിലാണ്. മാടായി പാറയുടെ തുടർച്ചയായി അതിന്റെ കിഴക്കു ഭാഗത്തായി വരുന്ന കുന്നിൻപ്രദേശവും താഴ്വാരവും ചേർന്ന പ്രദേശമാണിവിടം. കാർഷിക സമൃദ്ധിയും പൈതൃകവും ഒത്തുചേരുന്ന ചെങ്ങൽ, കലാ-കായിക കൂട്ടായ്മകൾക്കും വലിയ മുൻതൂക്കം നൽകുന്ന ഒരു സാംസ്കാരിക കേന്ദ്രമാണ്."
    },
    {
      id: 20,
      name: "കടന്നപ്പള്ളി",
      englishName: "Kadannappalli",
      icon: Trees,
      color: "from-amber-400 to-yellow-500",
      description: "കനകം വിളയുന്ന നാട് എന്ന അർത്ഥത്തിൽ കനകപ്പള്ളി എന്ന് ഈ ഗ്രാമം പണ്ട് അറിയപ്പെട്ടിരുന്നു. ഗ്രാമം എന്നർത്ഥം വരുന്ന ഹള്ളി എന്ന പദമാണ് ഉച്ചാരണഭേദം വന്ന് പള്ളി ആയി മാറിയത് എന്നും കരുതപ്പെടുന്നു. കനകപ്പള്ളി പിന്നീട് കടന്നപ്പള്ളിയായി. കൃഷി നടക്കുന്ന വിശാലമായ വയലുകൾ ഇന്നും ഗ്രാമത്തിന്റെ സവിശേഷതയാണ്."
    },
    {
      id: 21,
      name: "അടുത്തില",
      englishName: "Aduthila",
      icon: MapPin,
      color: "from-violet-400 to-purple-500",
      description: "കണ്ണൂർ ജില്ലയിലെ മാടായി, ഏഴോം എന്നീ ഗ്രാമപഞ്ചായത്തുകളിലായി വ്യാപിച്ചു കിടക്കുന്ന സാമാന്യം വലിയൊരു ഗ്രാമമാണ് അടുത്തില. അടുത്തിലയുടെ വടക്കു ഭാഗത്തുകൂടിയാണു രാമപുരം പുഴ ഒഴുകുന്നതു തെക്കു-പടിഞ്ഞാറു ഭാഗത്തായി മാടായി പാറയും സ്ഥിതി ചെയ്യുന്നു."
    },
    {
      id: 22,
      name: "വയലപ്ര",
      englishName: "Vayalapra",
      icon: Palmtree,
      color: "from-lime-400 to-green-500",
      description: "ചെറുതാഴം പഞ്ചായത്തിൽ സ്ഥിതിചെയ്യുന്ന ഗ്രാമമാണ് വയലപ്ര. വയലപ്രയുടെ സ്ഥലനാമത്തെക്കുറിച്ച് ഇതുവരെ 3 നിഗമനങ്ങൾ ഉണ്ടായി 1)വയലറ എന്ന പദത്തിൽ നിന്ന് 2)വയൽപ്പുറം എന്ന പദത്തിൽ നിന്ന് 3)ഏതു ഭാഗത്ത്‌ നിന്ന് നോക്കിയാലും വയൽ അപ്പുറമായി കാണുന്നതിനാൽ 'വയൽ അപ്പുറം' എന്നും ഇത് ലോപിച്ച് 'വയലപ്ര' ആയി എന്നും കരുതുന്നു."
    },
    // 🔥 NEW ADDITIONS 🔥
    {
      id: 23,
      name: "കുഞ്ഞിമംഗലം",
      englishName: "Kunhimangalam",
      icon: Landmark,
      color: "from-yellow-500 to-amber-600",
      description: "ഓട്ടുപാത്ര നിർമ്മാണത്തിന് കേരളമൊട്ടാകെ പ്രശസ്തമായ പൈതൃക ഗ്രാമം. വെങ്കലത്തിൽ തീർത്ത മനോഹരമായ വിളക്കുകളും ശിൽപങ്ങളും ഇവിടെ നിർമ്മിക്കപ്പെടുന്നു. വടക്കേ മലബാറിലെ പ്രധാന പൈതൃക കേന്ദ്രങ്ങളിലൊന്ന്."
    },
    {
      id: 24,
      name: "പട്ടുവം",
      englishName: "Pattuvam",
      icon: Trees,
      color: "from-green-500 to-emerald-600",
      description: "കുപ്പം പുഴയാൽ ചുറ്റപ്പെട്ടതും, കണ്ടൽക്കാടുകളാൽ സമ്പന്നവുമായ പ്രകൃതിരമണീയമായ പ്രദേശം. പുഴയോരക്കാഴ്ചകളും നാടൻ ശൈലിയും നിലനിർത്തുന്ന ശാന്തമായ ഗ്രാമം."
    },
    {
      id: 25,
      name: "കോട്ടക്കീൽ",
      englishName: "Kottakkeel",
      icon: MapPin,
      color: "from-rose-500 to-red-600",
      description: "എഴോത്തിനും പട്ടുവത്തിനും ഇടയിലായി സ്ഥിതി ചെയ്യുന്ന ശാന്തസുന്ദരമായ ഒരു ഗ്രാമം. കൈപ്പാടുകളും, പുഴയും ഇടകലർന്ന ഗ്രാമീണ പ്രകൃതി ഭംഗി നിറഞ്ഞ ഇടം."
    },
    {
      id: 26,
      name: "എഴിലോട്",
      englishName: "Ezhilode",
      icon: Building2,
      color: "from-blue-500 to-indigo-600",
      description: "ദേശീയപാതയോട് (NH) ചേർന്ന് കിടക്കുന്ന പ്രധാനപ്പെട്ട ഗ്രാമം. ഗതാഗത സൗകര്യങ്ങളാൽ വേഗത്തിൽ വളരുന്ന ഒരു പ്രദേശം കൂടിയാണിത്."
    },
    {
      id: 27,
      name: "ശ്രീസ്ഥ",
      englishName: "Sreestha",
      icon: Church,
      color: "from-orange-500 to-red-500",
      description: "ചെറുതാഴം ഗ്രാമപഞ്ചായത്തിൽ ഉൾപ്പെടുന്ന, ചരിത്രപ്രസിദ്ധമായ ക്ഷേത്രങ്ങളുള്ള പ്രദേശം. ക്ഷേത്രകലകൾക്കും അനുഷ്ഠാനങ്ങൾക്കും വലിയ പ്രാധാന്യം നൽകുന്ന നാട്."
    },
    {
      id: 28,
      name: "എടാട്ട്",
      englishName: "Edat",
      icon: Landmark,
      color: "from-cyan-500 to-blue-600",
      description: "പയ്യന്നൂരിന് തൊട്ടടുത്തായി സ്ഥിതി ചെയ്യുന്ന, നിരവധി വിദ്യാഭ്യാസ സ്ഥാപനങ്ങളുള്ള പ്രധാന കേന്ദ്രം. മണ്ഡലത്തിലെ വടക്കേ അറ്റത്തുള്ള അതിർത്തി ഗ്രാമം."
    }
  ];

  const filteredPlaces = placesData.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase()) ||
    item.englishName.toLowerCase().includes(search.toLowerCase()) ||
    item.description.toLowerCase().includes(search.toLowerCase())
  );

  const handlePageShare = async () => {
    const shareData = {
      title: "Villages in Kalliasseri | Info Payangadi",
      text: "കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ പ്രധാന ഗ്രാമങ്ങളുടെ ചരിത്രവും വിവരങ്ങളും അറിയാൻ ഈ ലിങ്ക് സന്ദർശിക്കുക.",
      url: "https://info.payangadilive.com/places" 
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.error("Error sharing:", err);
      }
    } else {
      navigator.clipboard.writeText(shareData.url);
      toast.success("ലിങ്ക് കോപ്പി ചെയ്തു! (Link Copied)");
    }
  };

  const handleIndividualShare = async (place) => {
    const shareData = {
      title: `${place.name} | Info Payangadi`,
      text: `📍 *${place.name} (${place.englishName})*\n\n${place.description}\n\nകൂടുതൽ വിവരങ്ങൾക്ക് Info Payangadi സന്ദർശിക്കുക.`,
      url: "https://info.payangadilive.com/places"
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.error("Error sharing:", err);
      }
    } else {
      navigator.clipboard.writeText(shareData.text);
      toast.success("വിവരങ്ങൾ കോപ്പി ചെയ്തു! (Copied)");
    }
  };

  return (
    <>
      <Helmet>
        <title>Explore Villages & Places | Info Payangadi</title>
        <meta name="description" content="കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ പ്രധാന ഗ്രാമങ്ങളുടെ ചരിത്രവും വിവരങ്ങളും." />
        <meta property="og:url" content="https://info.payangadilive.com/places" />
        <meta property="og:image" content="https://info.payangadilive.com/Infopayangadi.jpg" />
      </Helmet>

      {/* 🔥 COPY PREVENTION 🔥 */}
      <div 
        className="min-h-[100dvh] bg-[#F8FAFC] pb-24 selection:bg-teal-200 overflow-x-hidden relative select-none"
        onCopy={(e) => {
          e.preventDefault();
          toast.error("Copying is disabled!");
        }}
        onContextMenu={(e) => e.preventDefault()} 
      >
        
        {/* Background Glows */}
        <div className="absolute top-[-10%] left-[-10%] w-[350px] h-[350px] bg-teal-400/15 rounded-full blur-[100px] pointer-events-none"></div>
        <div className="absolute top-[20%] right-[-10%] w-[350px] h-[350px] bg-blue-400/10 rounded-full blur-[100px] pointer-events-none"></div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-8 md:pt-12 relative z-10">
          
          {/* 🌟 TITLE & SHARE SECTION 🌟 */}
          <div className="text-center mb-10 px-2 flex flex-col items-center">
            <div className="inline-flex items-center justify-center p-3.5 bg-white text-teal-600 rounded-2xl mb-3 shadow-[0_8px_30px_rgb(20,184,166,0.12)] border border-teal-50">
              <Compass size={32} strokeWidth={2.5} />
            </div>
            <h2 className="text-3xl sm:text-4xl font-black text-slate-800 tracking-tight">
              Explore <span className="text-teal-600">Villages</span>
            </h2>
            <p className="text-sm sm:text-base text-slate-500 mt-1 font-medium">നമ്മുടെ നാടിന്റെ ചരിത്രവും പൈതൃകവും</p>

            <motion.button
              whileTap={{ scale: 0.95 }}
              onClick={handlePageShare}
              className="mt-4 flex items-center gap-2 bg-white hover:bg-teal-50 text-slate-600 hover:text-teal-600 px-5 py-2.5 rounded-full shadow-sm border border-slate-200 transition-all duration-200 font-bold text-sm"
            >
              <Share2 size={16} strokeWidth={2.5} />
              Share Page
            </motion.button>
          </div>

          {/* CONTACT BANNER */}
          <div className="max-w-4xl mx-auto mb-6">
            <motion.div 
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-blue-50 border border-blue-100 rounded-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 shadow-sm"
            >
              <div className="flex items-start gap-3">
                <div className="bg-blue-100 p-2 rounded-full text-blue-600 flex-shrink-0 mt-0.5">
                  <Info size={20} strokeWidth={2.5} />
                </div>
                <div>
                  <h4 className="text-blue-900 font-bold text-sm sm:text-base">വിവരങ്ങൾ പൂർണ്ണമല്ലേ?</h4>
                  <p className="text-blue-700 text-xs sm:text-sm mt-0.5 leading-relaxed">
                    വിട്ടുപോയ സ്ഥലങ്ങൾ കൂട്ടിച്ചേർക്കാൻ നമ്മളെ സഹായിക്കാം.
                  </p>
                </div>
              </div>
              <button 
                onClick={() => navigate('/help')} 
                className="w-full sm:w-auto flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-xl font-bold text-sm transition-colors active:scale-95 shadow-sm whitespace-nowrap shrink-0"
              >
                Contact Us <ArrowRight size={16} />
              </button>
            </motion.div>
          </div>

          {/* SEARCH */}
          <div className="max-w-4xl mx-auto mb-10 px-1">
            <div className="relative group">
              <Search size={20} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-teal-500 transition-colors" strokeWidth={2.5} />
              <input
                type="text"
                placeholder="സ്ഥലത്തിന്റെ പേര് തിരയുക..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full pl-11 pr-4 py-3.5 rounded-2xl border border-slate-200 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.03)] focus:ring-4 focus:ring-teal-500/10 focus:border-teal-400 outline-none transition-all text-sm sm:text-base font-semibold text-slate-800 placeholder:text-slate-400"
              />
            </div>
          </div>

          {/* 🏞️ PLACES GRID */}
          <motion.div 
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6"
          >
            <AnimatePresence>
              {filteredPlaces.map((place) => {
                const Icon = place.icon;
                return (
                  <motion.div
                    key={place.id}
                    variants={itemVariants}
                    layout
                    className="bg-white rounded-[2rem] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 hover:shadow-[0_15px_40px_rgb(20,184,166,0.08)] transition-all duration-300 relative overflow-hidden group flex flex-col h-full"
                  >
                    <div className={`h-24 sm:h-28 bg-gradient-to-r ${place.color} relative flex items-center justify-center overflow-hidden`}>
                      <div className="absolute inset-0 bg-black/10"></div>
                      <Icon size={50} strokeWidth={1.5} className="text-white/80 drop-shadow-md group-hover:scale-110 transition-transform duration-500" />
                    </div>

                    <div className="p-5 sm:p-6 flex flex-col flex-grow">
                      <div className="mb-3 flex justify-between items-start">
                        <div>
                          <h3 className="text-xl sm:text-2xl font-black text-slate-800 leading-tight tracking-tight">
                            {place.name}
                          </h3>
                          <p className="text-[10px] sm:text-xs font-bold text-teal-600 uppercase tracking-widest mt-1">
                            {place.englishName}
                          </p>
                        </div>
                        <button
                          onClick={() => handleIndividualShare(place)}
                          className="p-2 bg-slate-50 hover:bg-slate-800 text-slate-400 hover:text-white rounded-xl transition-all duration-200"
                          title="Share"
                        >
                          <Share2 size={16} strokeWidth={2.5} />
                        </button>
                      </div>
                      
                      <p className="text-sm text-slate-500 font-medium leading-relaxed flex-grow text-justify">
                        {place.description}
                      </p>
                    </div>
                  </motion.div>
                );
              })}
            </AnimatePresence>
          </motion.div>

          {/* NO RESULTS */}
          {filteredPlaces.length === 0 && (
            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}
              className="col-span-full text-center py-16 bg-white rounded-[2.5rem] border border-dashed border-slate-200 mt-4"
            >
              <div className="inline-flex items-center justify-center p-4 bg-slate-50 rounded-2xl mb-4">
                <Compass size={32} className="text-slate-300" strokeWidth={2.5} />
              </div>
              <h3 className="text-lg sm:text-xl font-black text-slate-700 tracking-tight">സ്ഥലം കണ്ടെത്താനായില്ല</h3>
              <p className="text-slate-400 mt-1 text-sm font-medium">ലിസ്റ്റിൽ ലഭ്യമല്ല.</p>
            </motion.div>
          )}

        </div>
      </div>
    </>
  );
}